import React, { Component } from 'react'
//import { connect } from 'react-redux';
import {loggedIn} from '../lib/auth'
let RealDialogs = null;

class Dialogs extends Component {
  	constructor(props) {
    	super(props);
    	this.state = { isReady: RealDialogs !== null };
  	}

  	componentWillMount() {
  		//const {isEditor} = this.props
  		
  		//if(!isEditor) return
  		if (!loggedIn()) return
  		this.load()
  	}
  	
	componentWillReceiveProps() {
		if(loggedIn() && !RealDialogs) this.load()
	}

  	load() {
    	require.ensure('./admin', () => {
      		RealDialogs = require('./admin').RealDialogs;
      		if (!this.hasUnmounted) {
        		this.setState({ isReady: true });
      		}
    	});
  	}

  	componentWillUnmount() {
    	this.hasUnmounted = true;
  	}

  	render() {
  		return this.state.isReady ? <RealDialogs {...this.props} /> : null
  	}
}
export default Dialogs
//export default connect(state => ({isEditor: state.auth.isEditor}))(Dialogs);



// WEBPACK FOOTER //
// ./src/fm/admin/Dialogs.js